"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emitter = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _events = _interopRequireDefault(require("events"));
var _Menu = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Menu"));
var _Drawer = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Drawer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const emitter = exports.emitter = new _events.default();
class PopupSubMenu extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      visible: false,
      left: 200
    });
    _defineProperty(this, "onClose", () => {
      this.setState({
        visible: false
      });
    });
    this.eventEmitter = emitter;
    this.closeMenu = this.closeMenu.bind(this);
    this.handleAfterVisibleChange = this.handleAfterVisibleChange.bind(this);
  }
  componentDidMount() {
    this.on("PopupSubMenu:open", this.closeMenu);
  }
  componentWillUnmount() {
    this.off("PopupSubMenu:open", this.closeMenu);
  }
  on(eventName, listener) {
    this.eventEmitter.on(eventName, listener);
  }
  off(eventName, listener) {
    this.eventEmitter.removeListener(eventName, listener);
  }
  closeMenu(level) {
    if (!this.state.visible) return;
    if (level === null || level === undefined || this.props.level === level) {
      return this.setState({
        visible: false
      });
    }
  }
  handleMenuClick() {
    !this.state.visible && this.eventEmitter.emit("PopupSubMenu:open", this.props.level);
    this.setState(state => ({
      visible: !state.visible
    }));
  }
  handleAfterVisibleChange() {
    if (!this.menuItem) {
      return;
    }
    const el = _reactDom.default.findDOMNode(this.menuItem);
    if (!el) {
      return;
    }
    const pos = el.getBoundingClientRect();
    return this.setState({
      left: pos.left + pos.width
    });
  }
  render() {
    const {
      menu,
      children,
      title,
      id,
      ...rest
    } = this.props;
    const {
      left
    } = this.state;
    // const divProps = {};

    const childrenWithProps = _react.default.Children.map(children, child => /*#__PURE__*/_react.default.cloneElement(child, {
      ...rest,
      level: 0
    }));
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Menu.default.Item, _extends({
      key: id
    }, rest, {
      onClick: ev => this.handleMenuClick(menu),
      ref: ref => this.menuItem = ref
    }), title, /*#__PURE__*/_react.default.createElement("span", null, " ")), /*#__PURE__*/_react.default.createElement(_Drawer.default, {
      className: this.state.visible ? "" : "d-none",
      style: {
        left
      }
      // getContainer={this.drawer}
      ,
      title: menu.title,
      placement: "left",
      closable: true,
      visible: this.state.visible,
      onClose: this.onClose,
      width: 300,
      afterVisibleChange: this.handleAfterVisibleChange
    }, /*#__PURE__*/_react.default.createElement(_Menu.default, {
      theme: "light",
      mode: "inline",
      className: "side-menu"
    }, childrenWithProps)));
  }
}
exports.default = PopupSubMenu;